export function loadCSS(URI) {
    return new Promise(resolve => {
        if (document.getElementById(`css-${URI}`)) { // already loaded
            resolve();
            return;
        }
        ;
        const head = document.getElementsByTagName("head")[0];
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.type = "text/css";
        link.href = URI;
        link.id = `css-${URI}`;
        link.innerHTML = "";
        link.addEventListener("load", () => resolve());
        head.appendChild(link);
    });
}
